var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5",
    transform: "translate(-6 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4205",
    "data-name": "\\uD328\\uC2A4 4205",
    d: "M8.4,22H19.6A2.329,2.329,0,0,0,22,19.75v-6a2.329,2.329,0,0,0-2.4-2.25h-.8v-3A4.657,4.657,0,0,0,14,4,4.657,4.657,0,0,0,9.2,8.5v3H8.4A2.329,2.329,0,0,0,6,13.75v6A2.329,2.329,0,0,0,8.4,22ZM10.8,8.5a3.1,3.1,0,0,1,3.2-3,3.1,3.1,0,0,1,3.2,3v3H10.8ZM7.6,13.75A.776.776,0,0,1,8.4,13H19.6a.776.776,0,0,1,.8.75v6a.776.776,0,0,1-.8.75H8.4a.776.776,0,0,1-.8-.75Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4206",
    "data-name": "\\uD328\\uC2A4 4206",
    d: "M14.771,20.868v.987a.771.771,0,1,0,1.542,0v-.987a1.542,1.542,0,1,0-1.542,0Z",
    transform: "translate(-1.542 -3.597)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.83b823223bbe17607de0cb30ee293477.svg";
export { ForwardRef as ReactComponent };